module.exports = __webpack_public_path__ + "img/klevu.14504d5d.png";